<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link
        ><span class="pfimg3"
          ><i class="fa fa-angle-right" aria-hidden="true"></i></span
        ><a class="decoration">Employee Management </a
        ><span class="pfimg3"
          ><i class="fa fa-angle-right" aria-hidden="true"></i
        ></span>
        Manage Timesheet
      </h6>
      <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
      <div style="padding-bottom: 100px" class="container-fluid">

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div  class="row mb-2">
              <div class="col-md-3">
                <div class="form-group ">
                   <label class="custom-label" style="font-size: small;"><b>Client</b></label>
                  <v-select
                    class="font-size_def"
                    label="label"
                    :options="mcustomers"
                    v-model="alldata.customer"
                    placeholder="Select Client"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group ">
                    <label class="custom-label" style="font-size: small;"><b>Consultant</b></label>
                  <v-select
                    class="font-size_def"
                    label="label"
                    :options="users"
                    v-model="alldata.user"

                     placeholder="Select Consultant"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group mt-4">
                 
                  <button
                    type="button"
                    @click="loadMiinventory2()"
                    class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="table1"
          style="border: 0px; padding: 0px; min-height: 0px"
          class="navbar background_color"
        >
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px">
              <b-form-input
                id="filter-input"
                class="bdr-rad"
                v-model="filter"
                type="search"
                placeholder="Search"
                @input="loadMiinventory()"
              >
              </b-form-input>
            </b-input-group>
            <div style="margin-top: 11px" class="ms-2">
              <span class="custom-breadcrumb"
                ><b>Showing {{ totalRows }} items.</b></span
              >
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end"></div>
        </div>

        <div v-if="table1" class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div>
              <div v-if="table1" class="table-responsive">
                <b-table
                  responsive
                  style="font-size: small"
                  class="table-hover"
                  :items="all_data"
                  :fields="fields"
                  head-variant="dark"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  show-empty
                  small
                >
                </b-table>
              </div>
            </div>
            <div class="text-end">
              <a style="cursor: pointer;" @click="downloadExcel">
                <img
                  style="padding-left: 5px"
                  src="../../../public/img/excel.png"
                  width="70px"
                  alt="Evenware Logo"
                />
              </a>
            </div>
          </div>
        </div>


        <div
          v-if="table2"
          style="border: 0px; padding: 0px; min-height: 0px"
          class="navbar background_color"
        >
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px">
              <b-form-input
                id="filter-input"
                class="bdr-rad"
                v-model="filterall"
                type="search"
                placeholder="Search"
                @input="loadalldata()"
              >
              </b-form-input>
            </b-input-group>
            <div style="margin-top: 11px" class="ms-2">
              <span class="custom-breadcrumb"
                ><b>Showing {{ totalRowsall }} items.</b></span
              >
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end"></div>
        </div>

 <div v-if="table2" class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div>
              <div v-if="table2" class="table-responsive">
                <b-table
                  responsive
                  style="font-size: small"
                  class="table-hover"
                  :items="all_data_load"
                  :fields="fields2"
                  head-variant="dark"
                  :filter="filterall"
                  :filter-included-fields="filterOn"
                  show-empty
                  small
                >

                  <template #cell(action)="row">
                     
                          <button
                    type="button"
                    @click="loadMiinventory(row.item.created_by,row.item.client_id,row.item.consultant,row.item.client)"
                    class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
                  >
                    View
                  </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="text-end">
              <a style="cursor: pointer;" @click="downloadExcel">
                <img
                  style="padding-left: 5px"
                  src="../../../public/img/excel.png"
                  width="70px"
                  alt="Evenware Logo"
                />
              </a>
            </div>
          </div>
        </div>



      </div>
    </div>

    <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
    <content-footer></content-footer>
  </div>
</template>
    <script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  mounted() {
    this.loadCustomer();
    this.loadalldata();
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      table1: false,
      table2: true,

      file: null,
      // alldata:{
      //   'keyword':'',
      // },

     alldata: {
      user: { value: '' },
      customer: { value: '' }
    },

      filter: null,
      filterall: null,

      filterOn: [],
      users: [],
      mcustomers: [],
      totalRows: 0,
      totalRowsall: 0,

      all_data: [],
      all_data_load: [],

      fields: [
        { key: "day", label: "Day", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "comment", label: "Comment", sortable: true },
        { key: "from", label: "From", sortable: true },
        { key: "to", label: "To", sortable: true },
        { key: "hours", label: "Hours", sortable: true },
      ],
      fields2: [
        { key: "client", label: "Client", sortable: true },
        { key: "consultant", label: "Consultant", sortable: true },
        { key: "totalhours", label: "Total Hours", sortable: true },
        { key: "action", label: "Action", sortable: true },
       
      ],
    };
  },
  components: {
    "v-select": vSelect,
    ContentFooter,
    TopNavbar,
  },

  computed: {},

  methods: {
    async Createtimesheet() {
      this.$router.push("/timesheet/create");
    },

    downloadExcel() {
      if (!this.all_data.length) {
        alert("No data to export!");
        return;
      }

      const exportColumns = [
        { key: "day", label: "Day" },
        { key: "date", label: "Date" },
        { key: "comment", label: "Comment" },
        { key: "from", label: "From" },
        { key: "to", label: "To" },
        { key: "hours", label: "Hours" },
      ];

      const headers = exportColumns.map((col) => col.label);
      const dataRows = this.all_data.map((row) =>
        exportColumns.map((col) => row[col.key])
      );

      const worksheet = XLSX.utils.aoa_to_sheet([]);

      // Title
      XLSX.utils.sheet_add_aoa(worksheet, [["Timesheet Report"]], {
        origin: "A1",
      });
      worksheet["!merges"] = [
        {
          s: { r: 0, c: 0 },
          e: { r: 0, c: headers.length - 1 },
        },
      ];
      worksheet["A1"].s = {
        font: { bold: true, sz: 14 },
        alignment: { horizontal: "center" },
      };

      // Add header
      XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });

      // Add data
      XLSX.utils.sheet_add_aoa(worksheet, dataRows, { origin: "A3" });

      // Style column headers (Row 2)
      for (let i = 0; i < headers.length; i++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 1, c: i });
        worksheet[cellAddress].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "00B0F0" }, // Aqua blue background
          },
          alignment: { horizontal: "center" },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }

      worksheet["!cols"] = headers.map(() => ({ wch: 15 }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Timesheet");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "Timesheet_Data.xlsx");
    },

    async loadCustomer() {
      try {
        const { data } = await axios.get(
          "/mcustomer/customerload",
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
        this.mcustomers = data.customers;
        this.users = data.users;
      } catch (error) {
        console.log(error.response);
      }
    },
    async loadalldata() {
     
      try {
        const { data } = await axios.post(
          "/mproduct/timesheetalldata",
           { alldata: this.alldata },
          {
            params: {
              filterall: this.filterall,
            },
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
         this.all_data_load = data.all_data_load;
          this.totalRowsall = data.totalRowsall;
      } catch (error) {
        console.log(error.response);
      }
    },

    async loadMiinventory2() {
     
      try {
        // this.isLoading = true;
        const { data } = await axios.post(
          "/mproduct/indextimesheet",
          { alldata: this.alldata },
          {
            params: {
              filter: this.filter,
            },
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
        if (data.status == 200) {
          this.all_data = data.all_data;
          this.totalRows = data.totalRows;

          if (this.totalRows > 0) {
            this.table1 = true;
            this.table2 = false;
          }
        }

        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },

    async loadMiinventory(created_by,client_id,consultant,client) {
      console.log(created_by);
      this.alldata.user['value'] = created_by;
      this.alldata.user['label'] = consultant;
      this.alldata.customer['value']= client_id;
      this.alldata.customer['label']= client;
      try {
        // this.isLoading = true;
        const { data } = await axios.post(
          "/mproduct/indextimesheet",
          { alldata: this.alldata },
          {
            params: {
              filter: this.filter,
            },
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
        if (data.status == 200) {
          this.all_data = data.all_data;
          this.totalRows = data.totalRows;

          if (this.totalRows > 0) {
            this.table1 = true;
            this.table2 = false;
          }
        }

        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },
  },
};
</script>

    <style scoped>
.vs__dropdown-toggle {
  border-radius: 10px !important;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
</style>
